export class documentRequestUrl  {
    documentRequest = "sse/v1/document-request";
 }